import { tv } from 'tailwind-variants';

const titleStyles = tv({
    slots: {
        base: `
    iris:font-(family-name:--base-type-font-heading)
    iris:font-(--sem-type-weight-title)!
    iris:tracking-(--sem-type-tracking-title)
    iris:text-(--comp-color-content-type-title)
  `,
        leading: "iris:leading-(--sem-type-leading-title)",
    },
    variants: {
        size: {
            md: `
        iris:text-(length:--sem-type-size-title-md-mobile)
        iris:lg:text-(length:--sem-type-size-title-md-desktop)
      `,
            lg: `
        iris:text-(length:--sem-type-size-title-lg-mobile)
        iris:lg:text-(length:--sem-type-size-title-lg-desktop)
      `,
            xl: `
        iris:text-(length:--sem-type-size-title-xl-mobile)
        iris:lg:text-(length:--sem-type-size-title-xl-desktop)
      `,
            xxl: `
        iris:text-(length:--sem-type-size-title-xxl-mobile)
        iris:lg:text-(length:--sem-type-size-title-xxl-desktop)
      `,
        },
        inverse: {
            true: "iris:text-(--comp-color-content-type-title-inverse)",
        },
    },
    // Default variants for the titleStyles
    defaultVariants: {
        size: "md",
        inverse: false,
    },
});

export { titleStyles as default };
